<template>
  <div class="manage-service-content">
    <h3>服务内容管理</h3>

    <div v-show="!ifSelected">
      <el-form :inline="true" class="demo-form-inline" size="small">
        <el-form-item>
          <el-input
            v-model="search"
            style="width:130px"
            placeholder="查找关键字"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查找</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="cancelSearch">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="handleAdd"
            >添加服务内容</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :default-sort="{ prop: 'id', order: 'ascending' }"
        @sort-change="onSortChange"
      >
        <template v-for="col in Columns">
          <el-table-column
            align="center"
            v-if="col.ifShow"
            :prop="col.value"
            :width="col.width"
            :label="col.name"
            sortable="custom"
            :key="col.value"
            show-overflow-tooltip
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <template v-if="roleId == 1">
              <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
                >修改</el-button
              >
              <el-popconfirm
                confirm-button-text="确认删除"
                cancel-button-text="不用了"
                confirm-button-type="danger"
                cancel-button-type=""
                icon="el-icon-info"
                icon-color="red"
                title="警告：确认删除？此操作会删除该服务内容选项，请谨慎操作"
                @confirm="handleDel(scope.$index, scope.row)"
              >
                <el-button type="danger" size="mini" slot="reference"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
            <span v-else style="color: #C0C4CC; font-size: 12px;">无权限</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageSize"
        :layout="paginationLayout"
        :small="ifSmall"
        :total="dataCount"
      >
      </el-pagination>
      <el-dialog title="添加服务内容" :visible.sync="ifShowAddDialog" width="90%">
        <el-form
          ref="addForm"
          class="demo-form-inline"
          :model="addForm"
          label-position="top"
        >
          <el-form-item label="服务内容名称" prop="name">
            <el-input
              type="text"
              placeholder="请输入服务内容名称"
              v-model="addForm.name"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirmAdd" style="width:100%" :loading="loading"
              >添加</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="修改服务内容" :visible.sync="ifShowEditDialog" width="90%">
        <el-form
          ref="editForm"
          class="demo-form-inline"
          :model="editForm"
          label-position="top"
        >
          <el-form-item label="服务内容名称" prop="name">
            <el-input
              type="text"
              placeholder="请输入服务内容名称"
              v-model="editForm.name"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="confirmEdit" style="width:100%" :loading="loading"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { addServiceContent, getServiceContentList, delServiceContent, updateServiceContent } from "../api";
import { mapGetters } from "vuex";
export default {
  name: "ManageServiceContent",
  data() {
    return {
      ifSmall: false,
      ifShowAddDialog: false,
      ifShowEditDialog: false,
      loading: false,
      paginationLayout: "prev, pager,next,  ->, total",
      ifSelected: false,
      addForm: {
        name: "",
      },
      editForm: {
        id: null,
        name: "",
      },
      Columns: [
        { name: "序号", value: "id", width: "80", ifShow: true },
        { name: "服务内容名称", value: "ContentName", width: "auto", ifShow: true },
      ],
      currentPage: 1,
      pageSize: 10,
      tableData: [{}],
      dataCount: 0,
      search: "",
      orderField: "id",
      orderMode: "asc",
    };
  },
  mounted() {
    this.getTableData();
    if (document.documentElement.clientWidth < 720) {
      this.ifSmall = true;
    }
  },
  methods: {
    getTableData() {
      let params = new URLSearchParams();
      params.append("limit", this.pageSize);
      params.append("page", this.currentPage);
      params.append("key", this.search);
      if (this.orderField) {
        params.append("field", this.orderField);
        params.append("order", this.orderMode || "asc");
      }
      getServiceContentList(params)
        .then((res) => {
          this.tableData = res.data;
          this.dataCount = res.count;
        })
        .catch((failResponse) => {});
    },
    onSortChange(res) {
      if (res.order) {
        this.orderMode = res.order === "descending" ? "desc" : "asc";
        this.orderField = res.prop;
      } else {
        this.orderMode = "asc";
        this.orderField = "id";
      }
      this.currentPage = 1;
      this.getTableData();
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    handleAdd() {
      if (this.roleId != 1) {
        this.$message.warning('您没有权限添加服务内容');
        return;
      }
      this.ifShowAddDialog = true;
    },
    confirmAdd() {
      if (this.roleId != 1) {
        this.$message.warning('您没有权限添加服务内容');
        return;
      }
      if (!(this.addForm.name || '').trim()) {
        this.$message.warning('请输入服务内容名称');
        return;
      }
      
      let _this = this;
      _this.loading = true;
      let params = new URLSearchParams();
      params.append("name", this.addForm.name.trim());
      addServiceContent(params)
        .then((res) => {
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onSearch();
            _this.ifShowAddDialog = false;
            _this.addForm.name = "";
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {})
        .finally(() => {
          _this.loading = false;
        });
    },
    handleEdit(row) {
      if (this.roleId != 1) {
        this.$message.warning('您没有权限修改服务内容');
        return;
      }
      this.editForm.id = row.id;
      this.editForm.name = row.ContentName || "";
      this.ifShowEditDialog = true;
    },
    confirmEdit() {
      if (this.roleId != 1) {
        this.$message.warning('您没有权限修改服务内容');
        return;
      }
      if (!(this.editForm.name || '').trim()) {
        this.$message.warning('请输入服务内容名称');
        return;
      }

      let _this = this;
      _this.loading = true;
      let params = new URLSearchParams();
      params.append("id", this.editForm.id);
      params.append("name", this.editForm.name.trim());
      updateServiceContent(params)
        .then((res) => {
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onSearch();
            _this.ifShowEditDialog = false;
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {})
        .finally(() => {
          _this.loading = false;
        });
    },
    handleDel(index, row) {
      if (this.roleId != 1) {
        this.$message.warning('您没有权限删除服务内容');
        return;
      }
      
      let params = new URLSearchParams();
      params.append("ContentName", row.ContentName);
      let _this = this;
      delServiceContent(params)
        .then((res) => {
          if (res.code === 0) {
            _this.$message({
              message: res.msg,
              type: "success",
            });
            _this.onSearch();
          } else {
            _this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((failResponse) => {});
    },
    cancelSearch() {
      this.search = "";
      this.getTableData();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
  },
  computed: {
    ...mapGetters(["name", "roleId"]),
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
}
</style>
